// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ctBhP","title":"styles_title__2c0t2","child":"styles_child__X0GNg"};